import React from 'react';

class DialupModes extends React.Component {
    render() {
        return (
            <section className="mode">
                <div className="container"><h2 className="mode__title">Режимы дозвона</h2>
                    <div className="mode__block">
                        <div className="mode__item">
                            <div className="mode__underscore"></div>
                            <h3 className="mode__header">Базовый</h3><p className="mode__text">Система начинает набирать
                            номер, как только оператор переходит в состояние готовности. Когда респондент ответит на
                            вызов, звонок будет переведён на оператора.</p></div>
                        <div className="mode__item">
                            <div className="mode__underscore"></div>
                            <h3 className="mode__header">Прогрессивный</h3><p className="mode__text">Система инициирует
                            дозвон, как только оператор переходит в состояние готовности. В отличие от базового варианта
                            для каждого соединения набирается одновременно несколько (два или более) номеров. Первый
                            отвеченный вызов будет переведён оператору, остальные будут сброшены (в случае отсутствия
                            операторов в состоянии готовности).</p></div>
                        <div className="mode__item">
                            <div className="mode__underscore"></div>
                            <h3 className="mode__header">Предиктивный</h3><p className="mode__text">В своей работе
                            система опирается на статистику, учитывая среднее время, затрачиваемое на установление
                            соединения, среднее время разговора оператора, среднее время постобработки и другие
                            параметры. Набор номера может начаться, когда все операторы заняты – в расчёте на то, что
                            кто-то из них в ближайшее время освободится. Поскольку в данном режиме система оперирует
                            вероятностями, его эффективность зависит от однородности базы контактов, статистической
                            равномерности интервью и общего количества операторов, участвующих в проекте.</p></div>
                        <div className="mode__item">
                            <div className="mode__underscore"></div>
                            <h3 className="mode__header">Смешанный</h3><p className="mode__text">Сочетание предиктивного
                            режима с прогрессивным: идёт предвосхищающий набор номера с возможностью использования
                            нескольких каналов одновременно.</p></div>
                    </div>
                </div>
            </section>
        )
    }
}

export default DialupModes;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/DialupModes.js